import SRP_Search from './js-srp-mediator';
import PaginationAPC from './pagination-apc';
import { getPrependedUrlPath } from '../js-helpers/js-helpers';
import { FAMILY_FILTERS_REQUEST } from '../constants/requestHandlingOptions';

export default class Finder_Search extends SRP_Search {
    constructor(urlPrefix) {
        super();
        this.urlPrefix = urlPrefix;
    }

    handleResponse(result, targetElem) {
        const frag = document.createRange().createContextualFragment(result);

        if (targetElem === 'loadMore') {
            const originalListBlock = this.BLOCK.querySelector('.result-list');
            const originalPaginationaAPCBlock = this.BLOCK.querySelector('.js-pagination-apc');
            const originalLoadMoreButtonMobile = this.BLOCK.querySelector(
                '.js-location-filter-mob',
            );

            const resultListBlockItems = frag.querySelectorAll('.result-list__item');
            const paginationaAPCBlock = frag.querySelector('.js-pagination-apc');
            const updatedLoadMoreButtonMobile = frag.querySelector('.js-location-filter-mob');
            if (updatedLoadMoreButtonMobile) {
                updatedLoadMoreButtonMobile.addEventListener(
                    'click',
                    this.handleLocationFilterMobClick,
                );
            }

            const tmpDocFrag = document.createDocumentFragment();

            [...resultListBlockItems].forEach(argItem => {
                const isNode = argItem instanceof Node;
                tmpDocFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
            });

            const firstIndex = this.BLOCK.querySelector(
                '.search-result-indication-message__quantity_mobile span',
            ).innerHTML;

            originalListBlock.appendChild(tmpDocFrag);
            originalPaginationaAPCBlock.replaceWith(paginationaAPCBlock);
            if (updatedLoadMoreButtonMobile) {
                originalLoadMoreButtonMobile.replaceWith(updatedLoadMoreButtonMobile);
            }

            this.PAGINATION_COLLECTION = this.BLOCK.querySelectorAll('.js-pagination-apc');
            this.PAGINATION_ARRAY = [...this.PAGINATION_COLLECTION];

            if (this.PAGINATION_ARRAY && this.PAGINATION_ARRAY.length > 0) {
                this.handleTargetNodesArrays(
                    this.PAGINATION_ARRAY,
                    this.tmpArraysObj.paginationInstanceArr,
                    PaginationAPC,
                );
            }
            this.BLOCK.querySelector(
                '.search-result-indication-message__quantity_mobile span',
            ).innerHTML = firstIndex;
        } else if (result.indexOf('no-result-found__text') === -1) {
            const insertBlock = frag.querySelector('.js-srp-mediator-inner');

            this.BLOCK.innerHTML = '';
            this.BLOCK.appendChild(insertBlock);

            this.reinit();
        } else {
            const resultContainer = this.BLOCK.querySelector('.results-wrap');
            this.handleElementToggle('.result-list');

            if (!resultContainer.querySelector('.no-result-found-items-wrapper')) {
                resultContainer.appendChild(frag.querySelector('.no-result-found-items-wrapper'));
                this.handleCounterSetToZero('.search-result-indication-message__quantity');
                this.BLOCK.querySelector(
                    '.search-result-indication-message__inner',
                ).innerHTML = frag.querySelector(
                    '.search-result-indication-message__inner',
                ).innerHTML;
                this.handleElementToggle('.pagination-apc-outer-wrap');
                this.handleElementToggle('.toolbar');
                this.handleMobileResultsHide();
            } else {
                this.handleElementToggle('.result-list');
                this.handleElementToggle('.no-result-found-items-wrapper');
                window.history.back();
            }
        }

        document.dispatchEvent(this.fetchEnd);
    }

    handleMobileResultsHide = () => {
        if (window.innerWidth <= 960) {
            this.handleElementToggle('.filter-list_sorting-chosen');
            this.handleElementToggle('.search-result-indication-message_mobile');
        }
    };

    handleCounterSetToZero = className => {
        const element = document.querySelector(className);
        if (element) {
            element.textContent = '0';
        }
    };

    handleElementToggle = className => {
        const element = this.BLOCK.querySelector(className);
        element.classList.toggle('showHide');
    };

    sendRequest(ajaxParam, option = '', scrollToTop = false, isBack = false) {
        const source = `${this.AJAX_SRC}${ajaxParam}`;

        const fetchHeaders = new Headers({ 'Content-Type': 'text/html' });

        if (option === FAMILY_FILTERS_REQUEST) {
            document.dispatchEvent(this.fetchStartFromFamilyFilter);
        } else {
            document.dispatchEvent(this.fetchStart);
        }

        return fetch(source /* this.AJAX_SRC */, {
            method: 'get',
            credentials: 'same-origin',
            headers: fetchHeaders,
            cache: 'default',
        })
            .then(response => {
                if (!response.ok) throw new Error(response.statusText);
                return response.text();
            })
            .then(result => {
                this.handleResponse(result, option);
                return result;
            })
            .then(result => {
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
                // To prevent double search parameter in URL
                const locale = getPrependedUrlPath(this.urlPrefix);
                const newSource = `${locale}/${source}`;
                if (!isBack) {
                    history.pushState(
                        {
                            page: ajaxParam,
                            type: 'page',
                        },
                        null,
                        newSource,
                    );
                }
            })
            .catch(error => {
                document.dispatchEvent(this.fetchEnd);
                console.error(error);
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
            });
    }
}
